module.exports = __webpack_public_path__ + "static/media/register-pic.38a79be0.jpg";